/* ═══════════════════════════════════════════════════════════════
   assets/kioraa-popup.js
   Kioraa Launch Popup — Standalone script (never merged)
   ═══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var COOKIE_KEY  = 'kioraa_popup_seen';
  var STORAGE_KEY = 'kioraa_popup_emails'; /* shared with any other Kioraa forms */

  /* ── Get overlay ── */
  var overlay = document.getElementById('kioraa-popup-overlay');
  if (!overlay) return;

  /* ── Read settings from data attributes ── */
  var delay          = (parseInt(overlay.dataset.delay, 10) || 0) * 1000;
  var showOn         = overlay.dataset.showOn         || 'all';
  var specificHandle = overlay.dataset.specificHandle || '';
  var cookieDays     = parseInt(overlay.dataset.cookieDays, 10) || 7;
  var listId         = overlay.dataset.listId         || '';
  var companyId      = overlay.dataset.companyId      || '';
  var pageType       = overlay.dataset.pageType       || '';
  var pageHandle     = overlay.dataset.pageHandle     || '';

  /* ── Page type check ── */
  function shouldShowOnPage() {
    switch (showOn) {
      case 'all':        return true;
      case 'home':       return pageType === 'index';
      case 'product':    return pageType === 'product';
      case 'collection': return pageType === 'collection';
      case 'specific':   return pageHandle === specificHandle;
      default:           return true;
    }
  }

  /* ── Cookie helpers ── */
  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? m[1] : null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + '=' + value + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
  }

  /* ── localStorage: track submitted emails ── */
  /* NOTE: Klaviyo v3 client API ALWAYS returns 202 for both new and existing  */
  /* subscribers — it never returns 409. "Already subscribed" detection relies  */
  /* solely on localStorage (same device/browser). This key is shared across   */
  /* all Kioraa forms on the store so cross-form detection works on same device.*/
  function getSubmittedEmails() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function saveEmail(email) {
    try {
      var list  = getSubmittedEmails();
      var lower = email.toLowerCase();
      if (list.indexOf(lower) === -1) {
        list.push(lower);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      }
    } catch (e) {}
  }

  function wasAlreadySubmitted(email) {
    return getSubmittedEmails().indexOf(email.toLowerCase()) !== -1;
  }

  /* ── Show popup ── */
  function showPopup() {
    if (!shouldShowOnPage()) return;
    if (getCookie(COOKIE_KEY))  return;
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  /* ── Hide popup ── */
  function hidePopup() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setCookie(COOKIE_KEY, '1', cookieDays);
  }

  /* ── Manual open (announcement bar click, etc.) ──
     Force-opens regardless of cookie / page rules: an explicit click means
     the visitor wants to see it. Exposed globally so other sections can call it. */
  function openPopupManually() {
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  window.kioraaOpenPopup = openPopupManually;

  /* ── Close triggers ── */
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) hidePopup();
  });

  var closeBtn = overlay.querySelector('.kioraa-popup__close');
  if (closeBtn) closeBtn.addEventListener('click', hidePopup);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) hidePopup();
  });

  /* ── Show a message panel, hide the form ── */
  function showMessage(type) {
    var formEl = document.getElementById('kioraa-popup-form');
    if (formEl) formEl.style.display = 'none';

    ['success', 'subscribed', 'error'].forEach(function (t) {
      var el = document.getElementById('kioraa-popup-' + t);
      if (el) el.hidden = (t !== type);
    });

    if (type === 'success' || type === 'subscribed') {
      setCookie(COOKIE_KEY, '1', cookieDays);
      setTimeout(hidePopup, 4000);
    }
  }

  /* ── Form submit → Klaviyo v3 client API ── */
  var formEl = document.getElementById('kioraa-popup-form');
  if (formEl) {
    formEl.addEventListener('submit', function (e) {
      e.preventDefault();

      var emailInput = document.getElementById('kioraa-popup-email');
      var email      = emailInput ? emailInput.value.trim() : '';
      if (!email) return;

      /* Already submitted on this device? Show subscribed without API call */
      if (wasAlreadySubmitted(email)) {
        showMessage('subscribed');
        return;
      }

      if (!companyId || !listId) {
        console.warn('[Kioraa Popup] Set Klaviyo Public API Key & List ID in Customizer → Kioraa Popup.');
        showMessage('error');
        return;
      }

      var btn = formEl.querySelector('.kioraa-popup__button');
      if (btn) btn.disabled = true;

      fetch(
        'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId),
        {
          method: 'POST',
          headers: {
              'Content-Type': 'application/vnd.api+json',
              'Accept': 'application/vnd.api+json',
              'revision': '2024-10-15'
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'Kioraa Launch Popup',
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: email
                      }
                    }
                  }
                },
                relationships: {
                  list: {
                    data: {
                      type: 'list',
                      id: listId
                    }
                  }
                }
              }
            })
        }
      )
      .then(function (res) {
        if (res.ok) {
          saveEmail(email);
          showMessage('success');
        } else {
          res.text().then(function (txt) {
            console.error('[Kioraa Popup Klaviyo Error]', res.status, txt);
          });

          if (btn) btn.disabled = false;
          showMessage('error');
        }
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        showMessage('error');
      });
    });
  }

  /* ── Countdown Timer ── */
  var countdownEl = document.getElementById('kioraa-popup-countdown');
  if (countdownEl) {
    var targetStr = countdownEl.dataset.target || '';

    /* Parse as local time — format: YYYY-MM-DDTHH:MM:SS */
    var parts = targetStr.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})$/);
    if (parts) {
      var targetDate = new Date(
        parseInt(parts[1], 10),
        parseInt(parts[2], 10) - 1,
        parseInt(parts[3], 10),
        parseInt(parts[4], 10),
        parseInt(parts[5], 10),
        parseInt(parts[6], 10)
      );

      var daysEl  = document.getElementById('kpc-days');
      var hoursEl = document.getElementById('kpc-hours');
      var minsEl  = document.getElementById('kpc-mins');
      var secsEl  = document.getElementById('kpc-secs');

      function pad(n) { return n < 10 ? '0' + n : '' + n; }

      function tick() {
        var dist = targetDate.getTime() - Date.now();

        if (dist <= 0) {
          if (daysEl)  daysEl.textContent  = '00';
          if (hoursEl) hoursEl.textContent = '00';
          if (minsEl)  minsEl.textContent  = '00';
          if (secsEl)  secsEl.textContent  = '00';
          clearInterval(cdTimer);
          return;
        }

        if (daysEl)  daysEl.textContent  = pad(Math.floor(dist / 86400000));
        if (hoursEl) hoursEl.textContent = pad(Math.floor((dist % 86400000) / 3600000));
        if (minsEl)  minsEl.textContent  = pad(Math.floor((dist % 3600000)  / 60000));
        if (secsEl)  secsEl.textContent  = pad(Math.floor((dist % 60000)    / 1000));
      }

      tick();
      var cdTimer = setInterval(tick, 1000);
    }
  }

  /* ── Kick off with delay ── */
  setTimeout(showPopup, delay);

})();
